/**
 * @generated SignedSource<<13ee622c928e91ab826c9a73c70130a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraHorizontalNavigationContentOld$data = {
  readonly jira: {
    readonly containerNavigation: {
      readonly extensions?: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly scopeId?: string | null | undefined;
    };
  } | null | undefined;
  readonly jira_projectByIdOrKey?: {
    readonly __id: string;
    readonly softwareBoardCount: AGG$Long | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CustomTemplateProjectBanner" | "NavHeader_project" | "TabsContent_project">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NavHeader_query" | "TabsContent_query">;
  readonly " $fragmentType": "JiraHorizontalNavigationContentOld";
};
export type JiraHorizontalNavigationContentOld$key = {
  readonly " $data"?: JiraHorizontalNavigationContentOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraHorizontalNavigationContentOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "containerNavigationInput"
    },
    {
      "kind": "RootArgument",
      "name": "projectIdOrKey"
    },
    {
      "kind": "RootArgument",
      "name": "withProject"
    }
  ],
  "kind": "Fragment",
  "name": "JiraHorizontalNavigationContentOld",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TabsContent_query"
    },
    {
      "kind": "FragmentSpread",
      "name": "NavHeader_query"
    },
    {
      "condition": "withProject",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            },
            {
              "kind": "Variable",
              "name": "idOrKey",
              "variableName": "projectIdOrKey"
            }
          ],
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "TabsContent_project"
            },
            {
              "kind": "FragmentSpread",
              "name": "NavHeader_project"
            },
            {
              "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "CustomTemplateProjectBanner"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "softwareBoardCount"
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__id"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "containerNavigationInput"
              }
            ],
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "scopeId"
                  }
                ],
                "type": "JiraContainerNavigation"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      }
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          },
          "action": "THROW",
          "path": "jira.containerNavigation"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "e4dc6da4b0d59b8f65dba04e054173cf";

export default node;
